export default __webpack_public_path__ + "static/media/ISSO CLASS-4 EXAM PATTERN 2025.f3c594fa.pdf";